import { MATCH_STANDALONE } from './useIsPwa.constants'

type DisplayModes = 'browser' | 'standalone'

export const getDisplayMode = () => {
  let displayMode: DisplayModes = 'browser'
  const standaloneMatcher = window.matchMedia(MATCH_STANDALONE)
  if (standaloneMatcher.matches) {
    displayMode = 'standalone'
  }

  return { displayMode, standaloneMatcher }
}
